import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, AfterViewInit } from '@angular/core';
import { Location } from '@angular/common'
import { GlobalsService } from '../../services/globals.service'
import { InventoryService } from '../../services/inventory.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { UsersService } from '../../services/users.service';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, FormControl, UntypedFormGroup, ValidatorFn, AbstractControl } from '@angular/forms';

import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ConfigService } from 'app/services/config.service';

@Component({
	selector: 'app-sales-people',
	templateUrl: './sales-people.component.html',
	styleUrls: ['./sales-people.component.scss']
})
export class SalesPeopleComponent implements OnInit {
	@ViewChild('salesEdit') salesEditRef: ElementRef;
	salespeople: any = [];
	managers: any = [];
	zones: any = [];
	yesno: any = [
		{ value: '0', name: 'No' },
		{ value: '1', name: 'Yes' }
	];

	salesForm: UntypedFormGroup;
	brands: { manufacturer_id: number; name: string }[] = [];
	luxuryBrands: { manufacturer_id: number; name: string; granted: boolean }[] = [];

	constructor(
		private fb: UntypedFormBuilder,
		private globalsService: GlobalsService,
		private inventoryService: InventoryService,
		private globalSearchService: GlobalSearchService,
		private usersService: UsersService,
		private modalService: NgbModal,
		private configService: ConfigService
	) {}

	ngOnInit(): void {
		this.loadData();
		this.inventoryService.getItemManufacturer().subscribe((rows: any) => {
			const list = Array.isArray(rows) ? rows : [];
			this.brands = list
				.map((r: any) => ({
					manufacturer_id: Number(r.manufacturer_id),
					name: String(r.name ?? '').trim() || `Brand #${r.manufacturer_id}`,
				}))
				.filter((b) => Number.isFinite(b.manufacturer_id) && b.manufacturer_id > 0);
		});
		this.globalsService.getSalesManagers().subscribe((results: any) => {
			this.managers = results || [];
		});
		this.globalSearchService.zones.subscribe((results: any) => {
			this.zones = results;
		});
	}

	portalBrandLabel(manufacturerId: number): string {
		const row = this.brands.find((b) => b.manufacturer_id === manufacturerId);
		return row ? row.name : String(manufacturerId);
	}

	onPortalBrandsChange(): void {
		if (!this.salesForm) {
			return;
		}
		const ids = (this.salesForm.get('portal_manufacturer_ids')?.value || []) as number[];
		const defCtrl = this.salesForm.get('portal_default_manufacturer_id');
		const cur = defCtrl?.value != null && defCtrl.value !== '' ? Number(defCtrl.value) : null;
		if (cur != null && Number.isFinite(cur) && !ids.includes(cur)) {
			defCtrl?.setValue(ids.length ? ids[0] : null, { emitEvent: false });
		}
		if (!ids.length) {
			defCtrl?.setValue(null, { emitEvent: false });
		}
	}

	getIsManager(): boolean {
		const gl = this.salesForm?.get('group_level')?.value;
		return (parseInt(gl, 10) || 0) > 1;
	}

	addSalesPerson() {
		this.salesForm = this.fb.group({
			salesmancode: ['', Validators.required],
			salesmanname: ['', Validators.required],
			smantel: [''],
			smanfax: [''],
			commissionrate1: [''],
			breakpoint: [''],
			commissionrate2: [''],
			current: ['1'],
			chatid: [''],
			group_id: ['1'],
			group_level: ['0'],
			group_type: ['1'],
			username: [''],
			smanlogin: [''],
			smanpass: [''],
			smanaddr: [''],
			smancity: [''],
			smanstate: [''],
			smanzip: [''],
			smantab: [''],
			smancell: [''],
			smanemail: [''],
			access_level: ['0'],
			csremails: [''],
			commlock: ['0'],
			ismanager: [false],
			manager: [''],
			assinged_salespeople: [[]],
			portal_manufacturer_ids: [[]],
			portal_default_manufacturer_id: [null],
		});

		this.modalService.open(this.salesEditRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then(() => {}, () => {});
	}

	saveSalesPerson() {
		if (!this.salesForm) {
			return;
		}
		const code = String(this.salesForm.get('salesmancode')?.value ?? '').trim();
		const name = String(this.salesForm.get('salesmanname')?.value ?? '').trim();
		if (!code || !name) {
			this.salesForm.markAllAsTouched();
			this.globalSearchService.showNotification(
				'Salesperson code and name are required before saving.',
				'warning',
				'bottom',
				'right'
			);
			return;
		}
		const raw = this.salesForm.getRawValue();
		const payload = { ...raw };
		payload.group_level = payload.ismanager ? '2' : '0';
		delete payload.ismanager;
		const pids = Array.isArray(payload.portal_manufacturer_ids) ? payload.portal_manufacturer_ids.map((n: any) => Number(n)).filter((n: number) => n > 0) : [];
		payload.portal_manufacturer_ids = pids;
		const pdf = payload.portal_default_manufacturer_id != null && payload.portal_default_manufacturer_id !== '' ? Number(payload.portal_default_manufacturer_id) : null;
		payload.portal_default_manufacturer_id = pdf != null && Number.isFinite(pdf) && pids.includes(pdf) ? pdf : pids.length ? pids[0] : null;
		this.globalsService.saveSalesPerson(payload).subscribe({
			next: (result) => {
				this.salespeople = result;
				this.refreshLoggedInSalesmanSessionIfCodeMatches(payload.salesmancode);
				this.modalService.dismissAll();
				this.globalSearchService.showNotification('Salesperson saved', 'success', 'bottom', 'right');
			},
			error: (err: any) => {
				const msg =
					(typeof err?.error === 'string' && err.error) ||
					err?.error?.message ||
					err?.message ||
					'Could not save salesperson.';
				this.globalSearchService.showNotification(msg, 'danger', 'bottom', 'right');
			},
		});
	}
	get isMoovSetup(): boolean {
		const client = this.configService.getConfig()?.env?.client;
		return client === 'moov' || client === 'moov_sandbox';
	}

	loadLuxuryBrands(salesmancode: string): void {
		this.luxuryBrands = [];
		if (!salesmancode) return;
		this.globalsService.getLuxuryManufacturers(salesmancode).subscribe((rows: any) => {
			this.luxuryBrands = Array.isArray(rows)
				? rows.map((r: any) => ({
						manufacturer_id: Number(r.manufacturer_id),
						name: String(r.name ?? '').trim(),
						granted: r.granted == 1 || r.granted === true,
				  }))
				: [];
		});
	}

	editSalesPerson(salesperson: any) {
		this.globalsService.getSalesPerson({ salesman: salesperson.salesmancode }).subscribe((detail: any) => {
			const d = detail && detail.salesmancode ? detail : salesperson;
			const gl = parseInt(d.group_level, 10) || 0;
			this.salesForm = this.fb.group({
				salesmancode: [d.salesmancode, Validators.required],
				salesmanname: [d.salesmanname, Validators.required],
				smantel: [d.smantel],
				smanfax: [d.smanfax],
				commissionrate1: [d.commissionrate1],
				breakpoint: [d.breakpoint],
				commissionrate2: [d.commissionrate2],
				current: [d.current],
				chatid: [d.chatid],
				group_id: [d.group_id],
				group_level: [d.group_level],
				group_type: [d.group_type],
				username: [d.username],
				smanlogin: [d.smanlogin],
				smanpass: [d.smanpass],
				smanaddr: [d.smanaddr],
				smancity: [d.smancity],
				smanstate: [d.smanstate],
				smanzip: [d.smanzip],
				smantab: [d.smantab],
				smancell: [d.smancell],
				smanemail: [d.smanemail, Validators.required],
				access_level: [d.access_level],
				csremails: [d.csremails],
				commlock: [d.commlock],
				ismanager: [gl > 1],
				manager: [d.manager || ''],
				assinged_salespeople: [Array.isArray(d.assinged_salespeople) ? d.assinged_salespeople : []],
				portal_manufacturer_ids: [
					Array.isArray(d.portal_manufacturer_ids)
						? d.portal_manufacturer_ids.map((n: any) => Number(n)).filter((n: number) => n > 0)
						: [],
				],
				portal_default_manufacturer_id: [
					d.portal_default_manufacturer_id != null && d.portal_default_manufacturer_id !== ''
						? Number(d.portal_default_manufacturer_id)
						: null,
				],
			});
			this.loadLuxuryBrands(d.salesmancode);
			this.modalService.open(this.salesEditRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then(() => {}, () => {});
		});
	}

	removeSalesPerson(salesperson: any) {
		this.globalsService.removeSalesPerson(salesperson).subscribe(result => {
			if (result.success) {
				this.loadData()
				this.globalSearchService.showNotification(result.message, 'success', 'bottom', 'right');
			} else {

				this.globalSearchService.showNotification(result.message, 'danger', 'bottom', 'right');
			}
		});

	}

	loadData() {
		this.globalsService.getSalesPeople().subscribe(results => {
			this.salespeople = results;
		});
		this.globalSearchService.zones.subscribe((results: any) => {
			this.zones = results;
		});
	}

	private refreshLoggedInSalesmanSessionIfCodeMatches(savedSalesmancode: string): void {
		const auth = this.globalSearchService.user.getValue();
		const u = auth?.user;
		if (!auth?.pass || !u?.userid || !u?.issalesman) {
			return;
		}
		const norm = (s: any) => String(s ?? '').trim().toUpperCase();
		if (norm(u.salesman) !== norm(savedSalesmancode)) {
			return;
		}
		this.usersService.getUser(u.userid).subscribe((profile: any) => {
			this.globalSearchService.mergeSessionUserProfile(profile);
		});
	}
}
